import Vue from "vue";
import VueRouter from "vue-router";
import type { RouteConfig } from "vue-router";
import Login from "@/views/login/Login.vue";
import RedirectLogin from "@/views/login/RedirectLogin.vue";
import { MessageBox } from "element-ui";

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  // @ts-ignore
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/wechatlogin",
    name: "RedirectLogin",
    component: RedirectLogin,
  },
  {
    path: "/",
    component: () => import("@/views/home/Home.vue"),
    children: [
      {
        path: "/",
        name: "HomeNav",
        redirect: "/contract/list/2",
        // component: () => import("@/views/home/grid/GridNav.vue"),
      },
      {
        path: "/contract",
        name: "contract",
        component: () => import("@/views/contract/Contract.vue"),
        children: [
          {
            path: "new",
            name: "NewContract",
            component: () =>
              // import("@/views/contract/create/createContract.vue"),
              import("@/views/contract/create/Create.vue"),
          },
          {
            path: "edit/:id/",
            name: "EditContract",
            component: () =>
              // import("@/views/contract/create/createContract.vue"),
              import("@/views/contract/create/Create.vue"),
          },
          {
            path: "seal-approval/:id",
            name: "SealApproval",
            component: () =>
              // import("@/views/contract/create/createContract.vue"),
              import("@/views/contract/list/SealApproval/detail.vue"),
          },
          {
            path: "verify",
            name: "VerifyContract",
            component: () => import("@/views/contract/verify/VerifyContract.vue"),
          },
          {
            path: "address",
            name: "AddressBook",
            component: () => import("@/views/contract/address/mail_list.vue"),
          },
          {
            path: "list/:status",
            name: "ContractList",
            component: () => import("@/views/contract/list/contractList.vue"),
          },
          {
            path: "detail/:id/:fileId/:status",
            name: "ContractDetail",
            component: () => import("@/views/contract/detail/contractDetail.vue"),
          },
          // {
          //   path: "sent/:id/:fileId",
          //   name: "sentContract",
          //   component: () => import("@/views/contract/sent/sentContract.vue"),
          // },
          {
            path: "specifyLocationDetail/:contractId/:fileId/",
            name: "specifyLocationDetail",
            component: () => import("@/views/sign-main/SpecifyLocationSign/Detail.vue"),
          },
        ],
      },
      {
        path: "/contract/sign/:id/:fileId/:type",
        name: "sentContract",
        // component: () => import("@/views/sign-main/sign_main.vue"),
        component: () => import("@/views/sign-main/SignMain.vue"),
      },
      {
        path: "/contract/specifyLocationEdit/:contractId/:fileId/",
        name: "specifyLocationEdit",
        component: () => import("@/views/sign-main/SpecifyLocationSign/index.vue"),
      },
      {
        path: "/contract/specifyLocationSign/:contractId/:fileId/:type",
        name: "SpecifyLocationSign",
        component: () => import("@/views/sign-main/SpecifyLocationSign/Sign.vue"),
      },
      {
        path: "/person",
        name: "PersonSetting",
        component: () => import("@/views/personal-setting/PersonalSetting.vue"),
        children: [
          {
            path: "/person",
            name: "BaseInfo",
            component: () => import("@/views/personal-setting/base-info/BaseInfo.vue"),
          },
          {
            path: "real-name-auth",
            name: "RealNameAuth",
            component: () => import("@/views/personal-setting/base-info/real-name-auth/index.vue"),
          },
          {
            path: "sign",
            name: "SignSeal",
            component: () => import("@/views/personal-setting/user-seal/signCachet.vue"),
          },
          {
            path: "draw",
            name: "DrawSignModal",
            component: () => import("@/views/personal-setting/user-seal/drawSign.vue"),
          },
          {
            path: "integral",
            name: "Integral",
            component: () => import("@/views/personal-setting/integral/Integral.vue"),
          },
          {
            path: "role",
            name: "Role",
            component: () => import("@/views/personal-setting/role/Role.vue"),
          },
          {
            path: "authentication/:id/",
            name: "Authentication",
            component: () => import("@/views/personal-setting/authentication/index.vue"),
          },
          {
            path: "authenticationList",
            name: "AuthenticationList",
            component: () => import("@/views/personal-setting/authentication/list.vue"),
          },
        ],
      },
      {
        path: "/documents",
        name: "MyDocuments",
        component: () => import("@/views/my-documents/MyDocuments.vue"),
      },
    ],
  },
  {
    path: "/mobileDraw",
    name: "MobileDrawSign",
    component: () => import("@/views/personal-setting/user-seal/mobileDrawSign.vue"),
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((_to, from, next) => {
  let verifyContractEditState: any = localStorage.getItem("VerifyContractEditState");
  if (verifyContractEditState) {
    try {
      verifyContractEditState = JSON.parse(verifyContractEditState);
      if (!verifyContractEditState.isCreate && !verifyContractEditState.disabled && from.path.includes("/contract/detail")) {
        MessageBox.confirm("系统可能不会保存您所做的更改，是否要离开？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        })
          .then(() => {
            next();
            localStorage.removeItem("VerifyContractEditState");
          })
          .catch(() => {});
        return;
      }
    } catch (e) {
      console.error(e);
    }
  }
  next();
});

export default router;
